import React from "react";
import { Outlet } from "react-router-dom";

const Release: React.FC = () => {
  return <Outlet />;
};

export default Release;